import script from "./quick-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./quick-upload.vue?vue&type=script&setup=true&lang=js"

import "./quick-upload.vue?vue&type=style&index=0&id=686c98b7&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686c98b7"]])

export default __exports__